import { gql } from "@apollo/client";

export const CREATE_EMPLOYEE = gql`
  mutation createEmployee(
    $lastName: String!
    $firstName: String!
    $email: String!
    $role: String!
    $phoneNo: String!
    $name: String!
  ) {
    createEmployee(
      firstName: $firstName
      lastName: $lastName
      email: $email
      roleKey: $role
      phoneNo: $phoneNo
      name: $name
    ) {
      message
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation updateEmployee(
    $userId: String!
    $lastName: String!
    $firstName: String!
    $roleKey: String
    $phoneNo: String!
    $name: String!
  ) {
    updateEmployee(
      userId: $userId
      lastName: $lastName
      firstName: $firstName
      roleKey: $roleKey
      phoneNo: $phoneNo
      name: $name
    ) {
      status
      message
    }
  }
`;

export const UPDATE_EMPLOYEE_VERIFY_EMAIL_STATUS = gql`
  mutation setEmailVerify($email: String!) {
    resendVerifyEmail(email: $email) {
      message
    }
  }
`;
export const UPDATE_EMPLOYEE_RESEND_PWD = gql`
  mutation resendPwdAction($userId: String!) {
    setForceResetPassword(userId: $userId) {
      id
      firstName
      lastName
      isForceResetPassword
    }
  }
`;

export const UPDATE_EMPLOYEE_ACTIVATION_STATUS = gql`
  mutation setUserStatus(
    $userId: String!
    $status: Boolean!
    $organizationId: String
  ) {
    setUserStatus(
      userId: $userId
      status: $status
      organizationId: $organizationId
    ) {
      id
      isActive
    }
  }
`;
export const UPDATE_EMPLOYEE_APPROVE = gql`
  mutation verifyUserById(
    $roleKey: String
    $userId: String!
    $isUserVerified: Boolean!
    $userOrganizationId: String!
    $organizationId: String!
  ) {
    verifyUserById(
      userId: $userId
      isUserVerified: $isUserVerified
      userOrganizationId: $userOrganizationId
      organizationId: $organizationId
      roleKey: $roleKey
    ) {
      message
    }
  }
`;
